import {frontend} from 'pageflow-scrolled/frontend';

import {Ornament} from './Ornament';

frontend.contentElementTypes.register('ornament', {
  component: Ornament
});
